import React, { useState, useEffect, useRef } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Stack from "@mui/material/Stack";
import Typography from "@material-ui/core/Typography";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  root: { display: "flex", flexWrap: "wrap" },
  textField: { marginRight: theme.spacing(1), flex: 1 },
  btnWrapper: { position: "relative" },
}));

const FlowBuilderAddButtonPixModal = ({ open, onSave, onUpdate, data, close }) => {
  const classes = useStyles();
  const isMounted = useRef(true);
  const [activeModal, setActiveModal] = useState(false);
  const [textDig, setTextDig] = useState("");
  const [labels, setLabels] = useState({ title: "Adicionar Chave PIX ao fluxo", btn: "Adicionar" });

  useEffect(() => {
    if (open === "edit") {
      setLabels({ title: "Editar Chave PIX", btn: "Salvar" });
      setTextDig(data?.data?.message ?? "");
      setActiveModal(true);
    } else if (open === "create") {
      setLabels({ title: "Adicionar Chave PIX ao fluxo", btn: "Adicionar" });
      setTextDig("");
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open, data]);

  useEffect(() => () => { isMounted.current = false; }, []);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSave = () => {
    const message = (textDig || "").trim();
    if (open === "edit") {
      handleClose();
      onUpdate({ ...data, data: { message: message || "Sua chave PIX para recebimento:" } });
    } else {
      handleClose();
      onSave({ message: message || "Sua chave PIX para recebimento:" });
    }
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={activeModal}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        style={{ zIndex: 3000 }}
        PaperProps={{ style: { zIndex: 3000, position: "relative" } }}
        BackdropProps={{ style: { zIndex: 2999, backgroundColor: "rgba(0, 0, 0, 0.5)" } }}
      >
        <DialogTitle>{labels.title}</DialogTitle>
        <Stack spacing={2} sx={{ px: 2, pb: 2 }}>
          <Typography variant="body2" color="textSecondary">
            A chave PIX é obtida das configurações da empresa (Configuração Pix Efí). No WhatsApp será enviada a mensagem com a chave e um botão "Copiar chave PIX".
          </Typography>
          <TextField
            label="Mensagem (texto antes da chave)"
            placeholder="Sua chave PIX para recebimento:"
            rows={2}
            multiline
            variant="outlined"
            value={textDig}
            onChange={(e) => setTextDig(e.target.value)}
            fullWidth
          />
        </Stack>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" variant="outlined">
            {i18n.t("contactModal.buttons.cancel")}
          </Button>
          <Button color="primary" variant="contained" className={classes.btnWrapper} onClick={handleSave}>
            {labels.btn}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FlowBuilderAddButtonPixModal;
